module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_05_6DC79_1SD_GJI.b16d9986.png";